export default __webpack_public_path__ + "static/media/test_icon5.8ab0b0c9.svg";